import { Box, styled } from '@mui/material';

export default styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  backgroundColor: theme.palette.common.white,
  borderRadius: '4px',
}));
